import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-enrolled-section',
  templateUrl: './enrolled-section.component.html',
  styleUrls: ['./enrolled-section.component.css'],
})
export class EnrolledSectionComponent implements OnInit, OnDestroy, OnChanges {
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  testMessage: any;
  contentTileList: any = [];

  // subscriptions
  private _facilityOnChange: Subscription;

  @Input() isReloadRequired:boolean;
  @Output() updatedEnrolled: EventEmitter<String> = new EventEmitter(); 

  constructor(
    private rootScopeService: RootScopeService,
    public commonutil: CommonUtil,
    private _facilityService: FacilityService
  ) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit() {
    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
      this.generateContentTiles();
    });

    if (this.currentFacility['facilityId']) {
      this.generateContentTiles();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.isReloadRequired && this.currentFacility){
      this.generateContentTiles();
      this.updatedEnrolled.emit();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  generateContentTiles() {
    this.contentTileList = [];

    if (this.currentFacility.summary.statEmail === 'true') {
      let contentData: any = {};
      contentData.title = 'MONTHLY.EQUIPMENT.OVERVIEW';
      contentData.message = 'MONTHLY.EQUIPMENT.OVERVIEW.MESSAGE';

      contentData.enrolled = true;

      this.contentTileList.push(contentData);
    }

    if (this.currentFacility.summary.staffPermissionData.haloMediaOptedIn == 'true') {
      let contentData: any = {};
      contentData.title = 'HALO.MEDIA';
      contentData.message = this.getHaloMediaConsolesText();
      contentData.type = 'halomedia';
      contentData.enrolled = true;

      this.contentTileList.push(contentData);
    }
  }

  getHaloMediaConsolesText() {
    let haloConsoles: Array<string> = [];

    if (this.currentFacility.consoleEquipments != null) {
      for (let console of this.currentFacility.consoleEquipments) {
        if (
          console.consoleType === 'aquaman' ||
          console.consoleType === 'superman' ||
          console.consoleType === 'bluth' || 
          console.consoleType === 'hal'
        ) {
          haloConsoles.push(this.rootScopeData.consoleRights.get(console.consoleType).consoleName);
        }
      }

      let halomediStr: string = haloConsoles
        .join(', ')
        .replace(/,(?!.*,)/gim, ' ' + this.commonutil.translateText('AND'));
      let halomediaEnrolledMessage =
        this.commonutil.translateText('HALOMEDIA.ENROLLED.DESC') +
        ' ' +
        this.commonutil.translateText('HALOMEDIA.ENROLLED.NEW.MESSAGE');

      halomediStr = this.commonutil.replaceValueAsHTMLOnTranslatedText(halomediaEnrolledMessage, [halomediStr]);
      return halomediStr;
    }
    return '';
  }
}
